import type { ColumnMetadata } from '../grid/types';
import type { DetailFormApi } from '../detail-form/types';
import { JsMethodNotificationToast } from './JsMethodNotifications';
import { getDetailFormJsMethodConfig, getDetailFormJsMethodHandler } from './registry';
import {
  useJsMethodNotifications,
  useUnsupportedJsMethodNotifications,
} from './useJsMethodNotifications';

export const JsMethodDetailFormBindings = ({
  fields,
  form,
  contentKey,
  parentId,
  fieldName,
}: {
  fields: ColumnMetadata[];
  form: DetailFormApi;
  contentKey?: string;
  parentId?: string;
  fieldName?: string;
}) => {
  const { current, dismiss, notify } = useJsMethodNotifications();
  const fieldsToRender = fieldName
    ? fields.filter(
        (field) =>
          (field.dataField === fieldName || field.field === fieldName || field.key === fieldName) &&
          getDetailFormJsMethodConfig(field.nameJsMethod)?.renderBeforeField
      )
    : fields.filter((field) => !getDetailFormJsMethodConfig(field.nameJsMethod)?.renderBeforeField);
  useUnsupportedJsMethodNotifications(fieldName ? fieldsToRender : fields, 'detailForm', notify);

  return (
    <>
      {fieldsToRender.map((field, index) => {
        const config = getDetailFormJsMethodConfig(field.nameJsMethod);
        if (
          !fieldName &&
          config?.renderOnce &&
          fieldsToRender.findIndex(
            (candidate) => candidate.nameJsMethod?.trim() === field.nameJsMethod?.trim()
          ) !== index
        ) {
          return null;
        }

        const Handler = getDetailFormJsMethodHandler(field.nameJsMethod);
        if (!Handler) {
          return null;
        }

        return (
          <Handler
            key={`${field.key ?? field.dataField ?? field.field}:${field.nameJsMethod}`}
            field={field}
            fields={fields}
            form={form}
            contentKey={contentKey}
            parentId={parentId}
            onNotify={notify}
          />
        );
      })}
      <JsMethodNotificationToast current={current} onClose={dismiss} />
    </>
  );
};
